var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterNav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 72,
    viewBox: "0 0 1920 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1920 72V1.52642L1880.62 1.57395L1809.84 0.195427L1739.06 1.84332L1668.29 1.94366L1597.52 2.13908L1526.74 0L1455.97 1.50001L1385.19 1.69543L1314.42 1.74296L1243.65 1.57395L1172.88 1.72184L1102.11 0.396126L1031.34 1.79578L960.57 0.860916L889.8 1.6479L819.02 0.665497L748.25 1.66901L677.48 0.147896L606.71 1.03522L535.94 0.813385L465.17 1.89085L394.4 1.86972L323.63 0.417259L252.86 1.32571L182.09 2.1655L111.32 1.76937L40.55 0.78698L0 0.982399V72H1920Z",
    fill: "#676784"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterNav);
export default __webpack_public_path__ + "static/media/footer_nav.197ef55a584e3888b06012195dab63b5.svg";
export { ForwardRef as ReactComponent };